<template>
  <div class="lottery-list">
    <div class="top flex flex-col justify-between">
      <div class="mt-8 nav-bar">
        <div class="van-nav-bar__left" v-if="!isWechat()">
          <img src="../assets/images/back.svg" alt="" @click="$router.back()">
        </div>
        <div class="mx-auto">
          <span class="text-white">{{ $t('lottery_list.title') }}</span>
        </div>
      </div>
    </div>
    <van-list
        class="my-4 van-clearfix"
        v-model="loading"
        :finished="finish"
        :finished-text="$t('about.no_more')"
        @load="load">
      <van-cell v-for="item in list" :key="item.id" :title="getTitle(item)" :label="getLabel(item)" @click="onShowDetail(item)">
        <template #default>
          <span :style="getStatusColor(item)">{{getStatusTitle(item)}}</span>
        </template>
      </van-cell>
    </van-list>
    <lottery-detail-dialog ref="lotteryDetailDialog"></lottery-detail-dialog>
  </div>
</template>

<script>
import {isWechat} from '@/helpers/utils'
import LotteryDetailDialog from '../components/LotteryDetailDialog'
import lotteryMixin from '../helpers/lotteryMixin'

export default {
  mixins: [
    lotteryMixin
  ],
  components: {
    LotteryDetailDialog
  },
  data() {
    return {
      userInfo: {},
      list: [],
      listQuery: {
        page: 1,
      },
      loading: false,
      finish: false
    };
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    isWechat,
    getTitle(item) {
      return this.$t('lottery_list.code') + ': ' + item.code
    },
    getLabel(item) {
      return item.created_at + ' ' + item.cost + this.$t('lottery_list.tickets')
    },
    load() {
      this.$http.get('game/lucky_draw/records', {
        params: {page: this.listQuery.page++}
      })
          .then(result => {
            if (result.data && result.data.list && result.data.list.length) {
              this.list.push(...result.data.list);
              this.loading = false;
            } else {
              this.loading = false;
              this.finish = true;
            }
          })
    },
    goHomePage() {
      this.$router.push('/');
    },
    onClickBack() {
      this.$router.back();
    },
    onShowDetail(item) {
      this.$refs.lotteryDetailDialog.show(item);
    }
  },
}
</script>

<style lang="scss">
.nav-bar {
  position: relative;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  line-height: 1.5;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;
}

.lottery-list {
  .van-cell:nth-child(odd) {
    background-color: #000;
  }

  .van-cell:nth-child(even) {
    background-color: #1B1C1E;
  }

  .van-cell__title {
    color: #fff;
    flex-grow: 1;
  }

  .van-cell__value {
    span {
      position: relative;
      top: 10px;
      font-size: 14px;
      color: theme('colors.main');
    }
  }

  .van-cell::after {
    border: none;
  }

  .van-list__finished-text {
    //background-color: #1B1C1E;
  }
}
</style>
